import AssignTasksModalContent from './AssignTasksModalContent';

export default AssignTasksModalContent;
